import React, { useEffect, useState } from "react";
import { FaPlus, FaSearch, FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import _ from "lodash";

import { connect } from "react-redux";
import PActions from "../../Stores/redux/Persisted/Actions";
import UnpActions from "../../Stores/redux/Unpersisted/Actions";

import MainLayout from "../Common/MainLayout";
import DataTable from "../../Components/Table/DataTable";
import NewVisitorForm from "./NewVisitorForm";
import api from "../../Services/Api/api";

const UsersScreen = ({ users, user, setScreenState, officeCategories }) => {
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState("visitor");

  useEffect(() => {
    load();
  }, [userType]);

  // Filter & Search Logic
  useEffect(() => {
    let filtered = users;

    if (searchTerm) {
      filtered = filtered.filter((user) =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredUsers(filtered);
  }, [searchTerm, users]);

  const load = async () => {
    setLoading(true);
    try {
      let officeCategoriesData = officeCategories;
      if (!officeCategories) {
        let res = await loadOfficeTypes();
        officeCategoriesData = res.officeCategories;
      }

      const { users } = await api.get("v1/district-admin/user", {
        filter: JSON.stringify({
          where: { district: user.district._id, permissions: userType || [] },
          populate: [
            {
              path: "office",
              populate: [
                {
                  path: "subdivision block deptBlock circle lac type",
                },
              ],
            },
            {
              path: "image",
              select: "url filename",
            },
          ],
          sortby: "createdAt",
          order: -1,
        }),
      });

      console.log({ users, officeCategories, officeCategoriesData });

      setScreenState({
        users: users.map((x) => ({
          ...x,
          subdivisionName: x.office?.subdivision?.name,
          blockName: x.office?.block?.name,
          deptBlockName: x.office?.deptBlock?.name,
          circleName: x.office?.circle?.name,
          lacName: x.office?.lac?.name,
          officeName: x.office ? x.office?.name : x.officeName,
          typeName: x.office?.type?.name,
          categoryName: officeCategoriesData?.find(
            (y) => y._id === x.office?.type?.category
          )?.name,
          userPermissions: x.permissions?.map((p) => _.startCase(p)).join(", "),
          coordString: `${x.office?.coord?.lat || ""}-${
            x.office?.coord?.lng || ""
          }`,
          officeDetails: x.office?.details,
        })),
      });
    } catch (e) {
      console.error(e);
      toast.error(e.message);
    }
    setTimeout(() => {
      setLoading(false);
    }, 0);
  };

  const loadOfficeTypes = async () => {
    try {
      const { officeTypes, officeCategories } = await api.get(
        "v1/appdata/office-data"
      );
      setScreenState({ officeTypes, officeCategories }, false, "APP");

      return { officeCategories, officeTypes };
    } catch (e) {
      toast.error("Error loading data: " + e.message);
    }
  };

  const columns = [
    { label: "Name", accessor: "name" },
    { label: "Phone", accessor: "phone" },
    { label: "Email", accessor: "email" },
    { label: "User Type", accessor: "userPermissions" },
    { label: "Office Name", accessor: "officeName" },
    { label: "Designation", accessor: "designation" },

    { label: "Office Type", accessor: "typeName" },
    { label: "Office Category", accessor: "categoryName" },
    // { label: "Sub Division", accessor: "subdivisionName" },
    { label: "Block", accessor: "blockName" },
    // { label: "Dept Block", accessor: "deptBlockName" },
    // { label: "Circle", accessor: "circleName" },
    // { label: "LAC", accessor: "lacName" },
    // { label: "Office Location", accessor: "coordString" },
    // { label: "Office Details", accessor: "officeDetails" },
  ];

  return (
    <MainLayout screenName="users">
      <main className="users-screen">
        {/* Page Title & Actions */}
        <div className="page-header">
          <h1>
            Personnel And Inspectors{" "}
            {loading ? <FaSpinner className="spinner" /> : null}
          </h1>
          <button className="add-btn" onClick={() => setShowModal(true)}>
            <FaPlus /> Add New Visitor
          </button>
        </div>

        <div className="filters">
          <div className="search-bar">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="search-bar c1">
            <select
              value={userType}
              onChange={(e) => setUserType(e.target.value)}
            >
              <option value="visitor">Visitor</option>
              <option value="districtAdmin">District Admin</option>
              <option value="districtCommissioner">
                District Commissioner
              </option>
              <option value="">Other</option>
            </select>
          </div>
        </div>

        {/* Table */}
        <DataTable
          columns={columns}
          data={filteredUsers}
          searchable={false}
          emptyList={loading ? "Loading Data" : null}
        />

        {/* Modal for New User */}
        <NewVisitorForm
          key={(!!showModal).toString()}
          {...{
            isOpen: showModal,
            onClose: () => setShowModal(false),
            onSuccess: () => load(),
          }}
        />
      </main>
    </MainLayout>
  );
};

const SCREEN_NAME = "USERS_SCREEN";

const mapStateToProps = (state) => ({
  users: state.vState[SCREEN_NAME]?.users || [],
  officeTypes: state.vState.APP.officeTypes,
  officeCategories: state.vState.APP.officeCategories,
  user: state.pState.AUTH.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersScreen);
